export const PRODUCT_ROOT = '/products' as const
export const PAPER_PUMPKIN_PRODUCT = `${PRODUCT_ROOT}/paper-pumpkin-subscription` as const

// The PDP lives at /products/:slug. buildProductUrl returns null when the slug
// is missing so callers skip emitting the href entirely rather than link to
// /products/null. A null slug on a loaded product (e.g. a catalog record
// reached by ?itemId= whose slug is blank) was being stringified straight into
// the canonical / og:url / JSON-LD URLs, producing thousands of */null 404s
// that crawlers then followed. Ported from nuxt2 utils/categoryRoutes.ts, where
// it sits next to the shop routes; here it belongs with PRODUCT_ROOT, which
// nuxt4 already had. AB#62347
export const buildProductUrl = (
  slug: string | null | undefined,
  baseUrl = ''
): string | null => (slug ? `${baseUrl}${PRODUCT_ROOT}/${slug}` : null)
